import { Linking, Platform } from 'react-native';

export default async function openNotificationSettings() {
  try {
    if (Platform.OS === 'android' && process.env.EXPO_PUBLIC_PACKAGE_NAME) {
      await Linking.sendIntent('android.settings.APP_NOTIFICATION_SETTINGS', [
        {
          key: 'android.provider.extra.APP_PACKAGE',
          value: process.env.EXPO_PUBLIC_PACKAGE_NAME,
        },
      ]);
      return;
    }

    await Linking.openURL('app-settings:notifications');
  } catch {
    await Linking.openSettings();
  }
}
